import api from '../api/axios';
import { Agenda } from '../types/agenda';
import { decryptData } from '../utils/decrypt';

export const getAgendas = async (): Promise<Agenda[]> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/agenda`);
    
    const decrypted = decryptData(response.data, response.data.iv);
    
    return decrypted;

    // return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};
